// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { useFetchOne } from '../../hooks/useFetch';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import Loading from '../../components/common/Loading';
// import ErrorMessage from '../../components/common/ErrorMessage';
// import ReactMarkdown from 'react-markdown';
// import { FiFileText, FiDownload } from 'react-icons/fi';
// import SocialShares from '../../components/common/Socials/SocialShares';
// import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';


// const PublicationDetail = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.PUBLICATIONS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);


//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;
//     if (!post) {
//         return (
//             <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//                 <ErrorMessage message="İçerik bulunamadı" />
//                 <div className="text-center mt-8">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
//                     >
//                         ← Geri Dön
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const imageUrl = getMediaURL(post.image);
//     const pdfUrl = getMediaURL(post.pdf);

//     return (
//         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
//             {/* Breadcrumb */}
//             <nav className="mb-4 text-sm text-gray-600">
//                 <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <Link to={`/${URL_ENDPOINTS.PUBLICATIONS}`} className="text-blue-900 hover:underline">Yayınlar</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <span className="text-gray-800">{post.title}</span>
//             </nav>

//             {/* Back Button */}
//             <button
//                 onClick={() => navigate(-1)}
//                 className="inline-block mb-4 px-4 py-2 text-blue-900 font-medium rounded hover:bg-gray-100 transition-colors"
//             >
//                 ← Geri Dön
//             </button>

//             <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-blue-900 mb-6 leading-tight">
//                 {post.title}
//             </h1>

//             {/* Meta Information */}
//             <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-8 pb-4 border-b-2 border-gray-100">
//                 {post.publishedAt && (
//                     <span className="text-sm sm:text-base text-gray-600">
//                         Yayınlama tarihi: {formatDate(post.publishedAt)}
//                     </span>
//                 )}
//             </div>

//             {/* Article */}
//             <article className="bg-white rounded-lg shadow-md overflow-hidden">
//                 {/* Image */}
//                 {imageUrl && (
//                     <div className="w-full max-h-96 sm:max-h-[500px] overflow-hidden">
//                         <img
//                             src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                             alt={post.title}
//                             className="w-full h-auto object-cover"
//                         />
//                     </div>
//                 )}

//                 {/* Content */}
//                 <div className="p-6 sm:p-8 lg:p-10">




//                     {/* Description with Markdown */}
//                     <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
//                         <ReactMarkdown
//                             components={{
//                                 img: ({ node, ...props }) => (
//                                     <img
//                                         {...props}
//                                         className="max-w-full h-auto block my-4 rounded"
//                                         alt={props.alt || ''}
//                                     />
//                                 ),
//                                 p: ({ node, ...props }) => (
//                                     <p {...props} className="mb-4" />
//                                 ),
//                                 h1: ({ node, ...props }) => (
//                                     <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
//                                 ),
//                                 h2: ({ node, ...props }) => (
//                                     <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
//                                 ),
//                                 h3: ({ node, ...props }) => (
//                                     <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
//                                 ),
//                                 ul: ({ node, ...props }) => (
//                                     <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
//                                 ),
//                                 ol: ({ node, ...props }) => (
//                                     <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
//                                 ),
//                                 a: ({ node, ...props }) => (
//                                     <a {...props} className="text-blue-900 hover:underline" />
//                                 ),
//                             }}
//                         >
//                             {post.description}
//                         </ReactMarkdown>
//                     </div>

//                     {/* PDF Download Link */}
//                     {pdfUrl && (
//                         <div className="mb-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
//                             <a
//                                 href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="flex items-center gap-3 text-blue-900 hover:text-blue-700 font-medium transition-colors"
//                             >
//                                 <FiFileText className="w-6 h-6 flex-shrink-0" />
//                                 <span className="flex-1">Yayını indir</span>
//                                 <FiDownload className="w-5 h-5 flex-shrink-0" />
//                             </a>
//                         </div>
//                     )}

//                     {/* Full Content */}
//                     {post.content && (
//                         <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
//                             <p>{post.content}</p>
//                         </div>
//                     )}

//                     {/* Action Buttons */}
//                     <div className="flex flex-col sm:flex-row gap-4 mt-12 pt-8 border-t border-gray-200">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
//                         >
//                             ← Geri Dön
//                         </button>

//                         {/* <button
//                             onClick={() => window.print()}
//                             className="px-6 py-3 bg-white text-blue-900 border-2 border-blue-900 rounded font-medium hover:bg-blue-50 transition-colors"
//                         >
//                             🖨️ Yazdır
//                         </button> */}


//                     </div>
//                 </div>
//             </article>
//             <SocialShares />
//         </div>
//     );
// };

// export default PublicationDetail;





// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { useFetchOne } from '../../hooks/useFetch';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import Loading from '../../components/common/Loading';
// import ErrorMessage from '../../components/common/ErrorMessage';
// import ReactMarkdown from 'react-markdown';
// import { FiFileText, FiDownload } from 'react-icons/fi';
// import SocialShares from '../../components/common/Socials/SocialShares';
// import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';


// const PublicationDetail = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.PUBLICATIONS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);


//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;
//     if (!post) {
//         return (
//             <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//                 <ErrorMessage message="İçerik bulunamadı" />
//                 <div className="text-center mt-8">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
//                     >
//                         ← Geri Dön
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const imageUrl = getMediaURL(post.image);
//     const pdfUrl = getMediaURL(post.pdf);

//     return (
//         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-2 lg:py-4">
//             {/* Breadcrumb */}
//             <nav className="mb-4 text-sm text-gray-600">
//                 <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <Link to={`/${URL_ENDPOINTS.PUBLICATIONS}`} className="text-blue-900 hover:underline">Yayınlar</Link>
//                 <span className="mx-2 text-gray-400">/</span>
//                 <span className="text-gray-800">{post.title}</span>
//             </nav>

//             {/* Back Button */}
//             <button
//                 onClick={() => navigate(-1)}
//                 className="inline-block mb-4 px-4 py-2 text-blue-900 font-medium rounded hover:bg-gray-100 transition-colors"
//             >
//                 ← Geri Dön
//             </button>

//             <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-blue-900 mb-6 leading-tight">
//                 {post.title}
//             </h1>

//             {/* Meta Information */}
//             <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-8 pb-4 border-b-2 border-gray-100">
//                 {post.publishedAt && (
//                     <span className="text-sm sm:text-base text-gray-600">
//                         Yayınlama tarihi: {formatDate(post.publishedAt)}
//                     </span>
//                 )}
//             </div>

//             {/* Article - Side by Side Layout */}
//             <article className="bg-white rounded-lg shadow-md overflow-hidden">
//                 <div className="flex flex-col lg:flex-row">
//                     {/* Image - Left Side */}
//                     {imageUrl && (
//                         <div className="lg:w-2/5 xl:w-1/3 flex-shrink-0">
//                             <img
//                                 src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                                 alt={post.title}
//                                 className="w-full h-full object-cover lg:rounded-l-lg"
//                             />
//                         </div>
//                     )}

//                     {/* Content - Right Side */}
//                     <div className="flex-1 p-6 sm:p-8 lg:p-10">
//                         {/* Description with Markdown */}
//                         <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
//                             <ReactMarkdown
//                                 components={{
//                                     img: ({ node, ...props }) => (
//                                         <img
//                                             {...props}
//                                             className="max-w-full h-auto block my-4 rounded"
//                                             alt={props.alt || ''}
//                                         />
//                                     ),
//                                     p: ({ node, ...props }) => (
//                                         <p {...props} className="mb-4" />
//                                     ),
//                                     h1: ({ node, ...props }) => (
//                                         <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
//                                     ),
//                                     h2: ({ node, ...props }) => (
//                                         <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
//                                     ),
//                                     h3: ({ node, ...props }) => (
//                                         <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
//                                     ),
//                                     ul: ({ node, ...props }) => (
//                                         <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
//                                     ),
//                                     ol: ({ node, ...props }) => (
//                                         <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
//                                     ),
//                                     a: ({ node, ...props }) => (
//                                         <a {...props} className="text-blue-900 hover:underline" />
//                                     ),
//                                 }}
//                             >
//                                 {post.description}
//                             </ReactMarkdown>
//                         </div>

//                         {/* PDF Download Link */}
//                         {pdfUrl && (
//                             <div className="mb-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
//                                 <a
//                                     href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="flex items-center gap-3 text-blue-900 hover:text-blue-700 font-medium transition-colors"
//                                 >
//                                     <FiFileText className="w-6 h-6 flex-shrink-0" />
//                                     <span className="flex-1">Yayını indir</span>
//                                     <FiDownload className="w-5 h-5 flex-shrink-0" />
//                                 </a>
//                             </div>
//                         )}

//                         {/* Full Content */}
//                         {post.content && (
//                             <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
//                                 <p>{post.content}</p>
//                             </div>
//                         )}

//                         {/* Action Buttons */}
//                         <div className="flex flex-col sm:flex-row gap-4 mt-12 pt-8 border-t border-gray-200">
//                             <button
//                                 onClick={() => navigate(-1)}
//                                 className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
//                             >
//                                 ← Geri Dön
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </article>
//             <SocialShares />
//         </div>
//     );
// };

// export default PublicationDetail;



// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { useFetchOne } from '../../hooks/useFetch';
// import { getMediaURL, formatDate } from '../../utils/helpers';
// import Loading from '../../components/common/Loading';
// import ErrorMessage from '../../components/common/ErrorMessage';
// import ReactMarkdown from 'react-markdown';
// import { FiFileText, FiDownload } from 'react-icons/fi';
// import SocialShares from '../../components/common/Socials/SocialShares';
// import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';

// const PublicationDetail = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.PUBLICATIONS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;
//     if (!post) {
//         return (
//             <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//                 <ErrorMessage message="İçerik bulunamadı" />
//                 <div className="text-center mt-8">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
//                     >
//                         ← Geri Dön
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const imageUrl = getMediaURL(post.image);
//     const pdfUrl = getMediaURL(post.pdf);

//     return (
//         <div className="min-h-screen bg-gray-50">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
//                 {/* Breadcrumb */}
//                 <nav className="mb-6 text-sm text-gray-600">
//                     <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
//                     <span className="mx-2 text-gray-400">/</span>
//                     <Link to={`/${URL_ENDPOINTS.PUBLICATIONS}`} className="text-blue-900 hover:underline">Yayınlar</Link>
//                     <span className="mx-2 text-gray-400">/</span>
//                     <span className="text-gray-800">{post.title}</span>
//                 </nav>

//                 {/* Two Column Layout */}
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
//                     {/* Left Column - Image and Preview Button */}
//                     <div className="lg:col-span-1">
//                         <div className="sticky top-16">
//                             {/* Image Card */}
//                             {imageUrl && (
//                                 <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
//                                     <img
//                                         src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
//                                         alt={post.title}
//                                         className="w-full h-auto"
//                                     />
//                                 </div>
//                             )}

//                             {/* Preview Button */}
//                             {pdfUrl && (
//                                 <a
//                                     href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="block w-full"
//                                 >
//                                     <button className="w-full px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors">
//                                         PREVIEW
//                                     </button>
//                                 </a>
//                             )}
//                         </div>
//                     </div>

//                     {/* Right Column - Content */}
//                     <div className="lg:col-span-2">
//                         {/* Title */}
//                         <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
//                             {post.title}
//                         </h1>

//                         {/* Subtitle/Category */}
//                         <p className="text-lg text-gray-500 uppercase tracking-wide mb-6">
//                             REPORT
//                         </p>

//                         {/* Description */}
//                         <div className="prose prose-lg max-w-none text-gray-700 mb-8 leading-relaxed">
//                             <ReactMarkdown
//                                 components={{
//                                     img: ({ node, ...props }) => (
//                                         <img
//                                             {...props}
//                                             className="max-w-full h-auto block my-4 rounded"
//                                             alt={props.alt || ''}
//                                         />
//                                     ),
//                                     p: ({ node, ...props }) => (
//                                         <p {...props} className="mb-4" />
//                                     ),
//                                     h1: ({ node, ...props }) => (
//                                         <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
//                                     ),
//                                     h2: ({ node, ...props }) => (
//                                         <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
//                                     ),
//                                     h3: ({ node, ...props }) => (
//                                         <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
//                                     ),
//                                     ul: ({ node, ...props }) => (
//                                         <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
//                                     ),
//                                     ol: ({ node, ...props }) => (
//                                         <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
//                                     ),
//                                     a: ({ node, ...props }) => (
//                                         <a {...props} className="text-blue-900 hover:underline" />
//                                     ),
//                                 }}
//                             >
//                                 {post.description}
//                             </ReactMarkdown>
//                         </div>

//                         {/* Full Content */}
//                         {post.content && (
//                             <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
//                                 <p>{post.content}</p>
//                             </div>
//                         )}

//                         {/* Date */}
//                         {post.publishedAt && (
//                             <p className="text-lg text-gray-400 mb-8">
//                                 {formatDate(post.publishedAt)}
//                             </p>
//                         )}

//                         {/* PDF Download Link */}
//                         {pdfUrl && (
//                             <div className="mb-8">
//                                 <a
//                                     href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="inline-flex items-center gap-3 text-blue-900 hover:text-blue-700 font-medium transition-colors"
//                                 >
//                                     <FiDownload className="w-5 h-5" />
//                                     <span>Yayını indir</span>
//                                 </a>
//                             </div>
//                         )}

//                         {/* Back Button */}
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
//                         >
//                             ← Geri Dön
//                         </button>
//                     </div>
//                 </div>

//                 {/* Social Shares */}
//                 <div className="mt-12">
//                     <SocialShares />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PublicationDetail;









import { useParams, Link, useNavigate } from 'react-router-dom';
import { useFetchOne } from '../../hooks/useFetch';
import { getMediaURL, formatDate } from '../../utils/helpers';
import Loading from '../../components/common/Loading';
import ErrorMessage from '../../components/common/ErrorMessage';
import ReactMarkdown from 'react-markdown';
import { FiFileText, FiDownload } from 'react-icons/fi';
import SocialShares from '../../components/common/Socials/SocialShares';
import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';
import { toTurkishDate } from '../../utils/dateConvertToTr'
const PublicationDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { data: post, loading, error } = useFetchOne(API_ENDPOINTS.PUBLICATIONS, slug, POPULATE_PARAMS.ONE_WITH_IMAGES);

    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;
    if (!post) {
        return (
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <ErrorMessage message="İçerik bulunamadı" />
                <div className="text-center mt-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
                    >
                        ← Geri Dön
                    </button>
                </div>
            </div>
        );
    }

    // const imageUrl = getMediaURL(post.image);
    const imageUrl = post?.image
        ? getMediaURL(post.image)
        : '/placeholder_hor.jpg';
    const pdfUrl = getMediaURL(post.pdf);

    return (
        <div className="min-h-screen">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
                {/* Breadcrumb */}
                <nav className="mb-8 text-sm text-gray-600">
                    <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
                    <span className="mx-2 text-gray-400">/</span>
                    <Link to={`/${URL_ENDPOINTS.PUBLICATIONS}`} className="text-blue-900 hover:underline">Yayınlar</Link>
                    <span className="mx-2 text-gray-400">/</span>
                    <span className="text-gray-800">{post.title}</span>
                </nav>

                {/* Two Column Layout */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Left Column - Image and Preview Button */}
                    <div className="lg:col-span-1">
                        <div className="lg:sticky lg:top-24">
                            {/* Image Card - Standard book aspect ratio */}
                            {imageUrl && (
                                <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6 max-w-xs mx-auto">
                                    {/* Adjust aspect ratio here: aspect-[2/3] for standard book (width/height) */}
                                    <div className="aspect-[1/1.3] w-full">
                                        <img
                                            src={Array.isArray(imageUrl) ? imageUrl[0] : imageUrl}
                                            alt={post.title}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Preview Button */}
                            {pdfUrl && (
                                <a
                                    href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full"
                                >
                                    <button className="w-full px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors">
                                        Yayını indir
                                    </button>
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Right Column - Content */}
                    <div className="lg:col-span-2">
                        {/* Title */}
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                            {post.title}
                        </h1>

                        {/* Subtitle/Category */}
                        <p className="text-lg text-gray-500 uppercase tracking-wide mb-6">
                            YAYIN
                        </p>

                        {/* Description */}
                        <div className="prose prose-lg max-w-none text-gray-700 mb-8 leading-relaxed">
                            <ReactMarkdown
                                components={{
                                    img: ({ node, ...props }) => (
                                        <img
                                            {...props}
                                            className="max-w-full h-auto block my-4 rounded"
                                            alt={props.alt || ''}
                                        />
                                    ),
                                    p: ({ node, ...props }) => (
                                        <p {...props} className="mb-4" />
                                    ),
                                    h1: ({ node, ...props }) => (
                                        <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />
                                    ),
                                    h2: ({ node, ...props }) => (
                                        <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />
                                    ),
                                    h3: ({ node, ...props }) => (
                                        <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />
                                    ),
                                    ul: ({ node, ...props }) => (
                                        <ul {...props} className="list-disc list-inside mb-4 space-y-2" />
                                    ),
                                    ol: ({ node, ...props }) => (
                                        <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />
                                    ),
                                    a: ({ node, ...props }) => (
                                        <a {...props} className="text-blue-900 hover:underline" />
                                    ),
                                }}
                            >
                                {post.description}
                            </ReactMarkdown>
                        </div>

                        {/* Full Content */}
                        {post.content && (
                            <div className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
                                <p>{post.content}</p>
                            </div>
                        )}

                        {/* Date */}
                        {post.publishedAt && (
                            <p className="text-lg text-gray-400 mb-8">
                                {toTurkishDate(post.publishedAt)}
                            </p>
                        )}

                        {/* PDF Download Link */}
                        {/* {pdfUrl && (
                            <div className="mb-8">
                                <a
                                    href={Array.isArray(pdfUrl) ? pdfUrl[0] : pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-3 text-blue-900 hover:text-blue-700 font-medium transition-colors"
                                >
                                    <FiDownload className="w-5 h-5" />
                                    <span>Yayını indir</span>
                                </a>
                            </div>
                        )} */}

                        {/* Back Button */}
                        <button
                            onClick={() => navigate(-1)}
                            className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
                        >
                            ← Geri Dön
                        </button>
                    </div>
                </div>

                {/* Social Shares */}
                <div className="mt-12">
                    <SocialShares />
                </div>
            </div>
        </div>
    );
};

export default PublicationDetail;